module.exports = __webpack_public_path__ + "files/f8ed222cc0125f3b6dc3148e18af8c13.svg";